<template>
  <VueApexCharts :options="chartOptions" :series="series" />
</template>

<script setup>

import { defineProps, computed } from 'vue'
import VueApexCharts from 'vue3-apexcharts'

const props = defineProps({
  data: {
    type: Array,
    required: true,
  },
  title: {
    type: String,
    required: true,
    default: "No title",
  },
})

const ratings = Array(5).fill(0).map((_, index) => index + 1).reverse();

const countByRating = (rating) =>
  computed(() => props.data.filter((review) => review.rating === rating).length);

const series = computed(() => ratings.map((rating) => countByRating(rating).value));

const chartOptions = {

  chart: {
    type: 'donut',
    foreColor: 'white'
  },

  title: {
    text: props.title,
  },

  tooltip: {
    theme: 'dark',
  },

  labels: ratings,


}

</script>
